import React from "react";
import { Helmet } from "react-helmet";
import FaithThatWorks from "../components/Faith/FaithThatWorks";

const FaithThatWorksPage = () => {
  return (
    <>
      <Helmet>
        <title>Faith That Works — APE Framework | Adeolu Adegbemi</title>

        <meta
          name="description"
          content="Faith That Works is a prophetic + systematic framework built on APE: Anticipate, Prepare, Execute. Learn how spiritual clarity meets operational excellence to produce predictable success."
        />
        <meta
          name="keywords"
          content="Faith That Works, APE framework, Anticipate Prepare Execute, prophetic systems, spiritual leadership, Adeolu Adegbemi, Blueprint Architect, faith-based growth, success systems"
        />
        <meta name="author" content="Adeolu Adegbemi" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://adeoluadegbemi.com/faith-that-works"
        />
        <meta property="og:title" content="Faith That Works — APE Framework" />
        <meta
          property="og:description"
          content="A prophetic-meets-systemic framework for leaders who want clarity, structure, and consistent results. Experience APE: Anticipate, Prepare, Execute."
        />
        <meta
          property="og:image"
          content="https://adeoluadegbemi.com/og-faith-that-works.jpg"
        />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://adeoluadegbemi.com/faith-that-works"
        />
        <meta
          property="twitter:title"
          content="Faith That Works — APE Framework"
        />
        <meta
          property="twitter:description"
          content="Learn the APE Framework: Anticipate, Prepare, Execute. A faith-driven model for clarity, structure, and supernatural productivity."
        />
        <meta
          property="twitter:image"
          content="https://adeoluadegbemi.com/twitter-faith-that-works.jpg"
        />

        <link
          rel="canonical"
          href="https://adeoluadegbemi.com/faith-that-works"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <FaithThatWorks />
    </>
  );
};

export default FaithThatWorksPage;
